
import React, { useState } from 'react';
import { LogOut, Menu } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetTrigger,
} from "@/components/ui/sheet";
import { ScrollArea } from "@/components/ui/scroll-area";
import { MobileNavLink } from './NavLink';
import Logo from './Logo';
import { User } from '@supabase/supabase-js';

interface MobileNavProps {
  user: User | null;
  isDriver: boolean;
  signOut: () => void;
}

const MobileNav: React.FC<MobileNavProps> = ({ user, isDriver, signOut }) => {
  const [isOpen, setIsOpen] = useState(false);
  
  return (
    <div className="md:hidden flex items-center">
      <Sheet open={isOpen} onOpenChange={setIsOpen}>
        <SheetTrigger asChild>
          <Button variant="ghost" size="sm" className="h-10 w-10 p-0 rounded-full hover:bg-primary/10 transition-colors">
            <Menu className="h-5 w-5" />
            <span className="sr-only">Toggle menu</span>
          </Button>
        </SheetTrigger>
        <SheetContent side="right" className="pr-0 border-l border-border/50 bg-background/95 backdrop-blur-md">
          <Logo className="mb-8" onOpenChange={setIsOpen} />
          <ScrollArea className="my-4 h-[calc(100vh-8rem)] pb-10 pl-6">
            <div className="flex flex-col space-y-1">
              <MobileNavLink to="/" onOpenChange={setIsOpen} className="py-3 px-4 rounded-lg hover:bg-primary/10 transition-all duration-200">
                Home
              </MobileNavLink>
              <MobileNavLink to="/how-it-works" onOpenChange={setIsOpen} className="py-3 px-4 rounded-lg hover:bg-primary/10 transition-all duration-200">
                How It Works
              </MobileNavLink>
              <MobileNavLink to="/safety" onOpenChange={setIsOpen} className="py-3 px-4 rounded-lg hover:bg-primary/10 transition-all duration-200">
                Safety
              </MobileNavLink>
              <MobileNavLink to="/about-us" onOpenChange={setIsOpen} className="py-3 px-4 rounded-lg hover:bg-primary/10 transition-all duration-200">
                About Us
              </MobileNavLink>
              {!user && (
                <MobileNavLink to="/demo" onOpenChange={setIsOpen} className="py-3 px-4 rounded-lg text-primary font-medium hover:bg-primary/10 transition-all duration-200">
                  Demo
                </MobileNavLink>
              )}
              
              {user ? (
                <>
                  <MobileNavLink to="/rides" onOpenChange={setIsOpen} className="py-3 px-4 rounded-lg hover:bg-primary/10 transition-all duration-200">
                    My Rides
                  </MobileNavLink>
                  {isDriver && (
                    <MobileNavLink to="/driver-dashboard" onOpenChange={setIsOpen} className="py-3 px-4 rounded-lg hover:bg-primary/10 transition-all duration-200">
                      Driver Dashboard
                    </MobileNavLink>
                  )}
                  <MobileNavLink to="/profile" onOpenChange={setIsOpen} className="py-3 px-4 rounded-lg hover:bg-primary/10 transition-all duration-200">
                    Profile
                  </MobileNavLink>
                  <button
                    onClick={() => {
                      signOut();
                      setIsOpen(false);
                    }}
                    className="flex items-center py-3 px-4 text-destructive hover:bg-destructive/10 rounded-lg transition-colors duration-200"
                  >
                    <LogOut className="mr-2 h-4 w-4" />
                    <span>Log out</span>
                  </button>
                </>
              ) : (
                <>
                  <MobileNavLink to="/driver-signup" onOpenChange={setIsOpen} className="py-3 px-4 rounded-lg hover:bg-primary/10 transition-all duration-200">
                    Become a Driver
                  </MobileNavLink>
                  <div className="pt-4">
                    <MobileNavLink to="/auth" onOpenChange={setIsOpen} className="py-3 px-4">
                      <Button className="w-full rounded-xl bg-gradient-to-r from-primary to-secondary hover:opacity-90 transition-opacity">
                        Sign In
                      </Button>
                    </MobileNavLink>
                  </div>
                </>
              )}
            </div>
          </ScrollArea>
        </SheetContent>
      </Sheet>
    </div>
  );
};

export default MobileNav;
